import { useMutation } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { signIn } from "../api/authAPI";
import Spinner from "../components/UI/Spinner";
import TextField from "../components/UI/TextField";
import { useAuthStore } from "../store/authStore";

import bg from "../assets/signInBg.png";
import LoginHeader from "../components/UI/LoginHeader";
import { ToastContainer, toast } from "react-toastify";
import Cookies from "js-cookie"

const LoginPage = () => {
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();
  const { isLoading, isSuccess, mutate, data, error } = useMutation({
    mutationFn: signIn,
    // onError(err) {
    //   toast("error", "Invalid Credentials")
    // },

  });
  const { setToken, addUser, setIsPilot } = useAuthStore((state) => state);
  const submitlogin = () => {
    const payload = getValues();
    mutate(payload);
  };
  const navigate = useNavigate();
  useEffect(() => {
    if (isSuccess && data) {
      // add user to store

      // change message
      if (data.data.success) {
        addUser(data.data.data);
        setIsPilot(data?.data?.data?.data?.userType == "pilot" ? true : false)
        Cookies.set("access_token", data.data.data.token, { expires: 1 / 24, domain: "localhost" })
        Cookies.set("access_token", data.data.data.token, { expires: 1 / 24, domain: "tsaw.tech" })
        setToken(data.data.data.token);
        navigate("/");
      } else {
        // toast("error", data.data.message);
      }
    }
  }, [isSuccess]);
  useEffect(() => {
    toast?.error(error?.response?.data?.message)
  }, [error])
  return (
    <div className="login-wrap w-screen h-screen flex items-center justify-center bg-slate-100">
      <ToastContainer />
      <img className="absolute w-full h-full" src={bg} alt="bg" />
      <div className="login-card w-3/12 z-10 shadow-md p-8 bg-white rounded-xl">
        <LoginHeader />
        <br />
        <h1 className="text-3xl font-light">Login</h1>
        <br />
        {/* <h1 className="text-6xl text-center font-light text-slate-400">Login</h1>
        <br /> */}
        <form onSubmit={handleSubmit(submitlogin)} className="form">
          <TextField
            label="email"
            placeholder={"Enter your email"}
            inputProps={{ ...register("email", { required: true }) }}
          />
          <TextField
            label="password"
            placeholder={"Enter your password"}
            type="password"
            inputProps={{ ...register("password", { required: true }) }}
          />
          <span className="flex justify-between w-full">
            <Link
              to="/signup"
              className="text-tblu hover:underline cursor-pointer "
            >
              New to UTM? Sign up here
            </Link>
            <Link
              to={"/forget-password"}
              className="text-tblu hover:underline cursor-pointer">
              Forget password
            </Link>
          </span>
          <br />
          <br />
          <button
            onClick={handleSubmit(submitlogin)}
            className="text-xl bg-tblu text-white grid items-center w-full p-4 rounded-xl"
          >
            {isLoading ? <Spinner /> : "Log in"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
